export default "__VITE_ASSET__DkzHm8FB__"